import styled from 'styled-components';

export const VehicleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 36px;

  .infiniteScroll {
    padding: 0 2px 10px 2px;
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  position: relative;
  min-width: fit-content;

  div:first-child {
    position: relative;

    &:hover:before {
      /*Triangulo*/
      content: '';
      width: 0;
      height: 0;
      position: absolute;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      /*Faz seta "apontar para baixo. Definir o valor como 'top' fará ela "apontar para cima" */
      /*Aqui entra a cor da "aba" do balão */
      border-top: 10px solid #fff;
      z-index: 112;
      top: -8px;
      left: 0px;
    }

    &:hover:after {
      content: 'Ver detalhes';
      position: absolute;
      color: ${({ theme }) => theme.colors.gray[900]};
      font-size: 12px;
      text-transform: initial;

      height: fit-content;
      width: fit-content;
      white-space: nowrap;

      padding: 0px 24px;
      z-index: 111;

      border-radius: 8px;

      top: -26px;
      left: -52px;

      box-shadow: 0px 4px 16px ${({ theme }) => theme.colors.gray[400]};
      background-color: ${({ theme }) => theme.colors.background.white};
    }
  }

  div {
    cursor: pointer;
    max-width: fit-content;
    height: fit-content;
    padding: 0px 0px;

    :hover {
      color: ${({ theme }) => theme.colors.orange.primary};
    }

    svg {
      color: ${({ theme }) => theme.colors.gray[500]};
      width: clamp(14px, 1.5vw, 24px);
      height: clamp(14px, 1.5vw, 24px);
    }
  }
`;

export const ExportContainer = styled.div`
  width: 100%;
  min-width: 500px;
  margin: 20px 0;

  label {
    display: none;
  }

  input {
    width: 100%;
    font-weight: 300;
    font-size: 14px;
    line-height: 24px;
    border: 1px solid #B4B4B4;
    
    &:hover {
      opacity: 0.85;
    }
  }

`;

export const FiltersContainer = styled.div`
  display: grid;
  height: 100%;
  grid-template-columns: repeat(5, 1fr); 
  gap: 16px;

  @media (max-width: 1600px) {
    grid-template-columns: 1fr 1fr; 
  }

  > div,
  > label {
    flex: 1;
    min-width: 288px;
  }
  div button {
    width: 100%;
  }

  .inputSearch {
    position: relative;

    div {
      width: 100%;
    }

    input {
      width: 100%;
      padding-left: 44px;
      font-weight: 300;
      font-size: 14px;
    }

    span.debt-filter {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      border-radius: 12px;
      left: 0px;
      top: 0px;
      height: 48px;
      width: 40px;

      &:active {
        transform: translate(1px, 1px);
      }
      svg {
        color: ${({ theme }) => theme.colors.orange.primary};
        height: 20px;
        width: 20px;
      }
    }
  }

  .update-fleet {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
`;

export const CheckBoxInput = styled.input`
  cursor: pointer;
  margin-right: 12px;
  width: 16px;
  height: 16px;
  border: none;
  text-decoration: none;
  outline: none;
`;

export const InfoCardsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  gap: 20px;
  width: 100%;
`;

export const MandatoryDebtsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 13px;

  span.title-children {
    text-align: center;
    color: #005FAE;
    font-size: 18px;
    font-weight: 500;
    line-height: 27px;
    margin-bottom: 7px;
  }

  .mandatory-debt {
    display: flex;
    flex-direction: column;

    .debt-type {
      font-size: 14px;
      font-weight: 600;
      line-height: 21px;
      color: #4D4C4D;
      margin-bottom: 5px;
    }

    .debt-desc {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #858585;

      span {
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        color: #4D4C4D;
      }
    }
  }
`;
